/* Vellen Hair v2 (EU): free-shipping bar in market currencies. Liquid renders the exact bar only in the shop currency (EUR); here the threshold is converted with Shopify.currency.rate and the card is filled in. Runs on load (cart page, drawer) and after every drawer refresh. */
(function () {
  function fmt(v, cur) { try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: cur }).format(v); } catch (e) { return cur + ' ' + v.toFixed(2); } }
  function fill(root) {
    Array.prototype.slice.call((root || document).querySelectorAll('[data-v2-free]')).forEach(function (el) {
      var c = window.Shopify && window.Shopify.currency, rate = parseFloat(c && c.rate) || 1;
      var limit = parseFloat(el.getAttribute('data-limit')) * rate, total = parseInt(el.getAttribute('data-total'), 10) / 100, cur = el.getAttribute('data-cur');
      var b = el.querySelector('b'), bar = el.querySelector('.v2-bar i');
      if (!(limit > 0) || !b || !bar) { return; }
      if (total >= limit) { el.classList.add('is-done'); b.textContent = el.getAttribute('data-done'); bar.style.width = '100%'; }
      else { el.classList.remove('is-done'); b.innerHTML = el.getAttribute('data-tpl').replace('%A%', fmt(limit - total, cur)); bar.style.width = Math.max(4, Math.round(total / limit * 100)) + '%'; }
      el.style.display = '';
    });
  }
  function start() {
    fill(document);
    var d = document.querySelector('[data-v2-drawer-content]');
    if (d && window.MutationObserver) { new MutationObserver(function () { fill(d); }).observe(d, { childList: true }); }
  }
  if (document.readyState !== 'loading') { start(); } else { document.addEventListener('DOMContentLoaded', start); }
})();
